import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Meta from 'vue-meta'
import VueScreen from 'vue-screen'
import VueMobileDetection from 'vue-mobile-detection'


Vue.use(Router)
Vue.use(Meta)
Vue.use(VueScreen, 'bootstrap')
Vue.use(VueMobileDetection)
const NotFound = Vue.component('NotFound', require('../components/generic/NotFound.vue').default);
const Auction = Vue.component('Auction', require('../components/Auction.vue').default);
const Search = Vue.component('Search', require('../components/Search.vue').default);
const Artist = Vue.component('Artist', require('../components/Artist.vue').default);

const Auctions = Vue.component('Auctions', require('../components/Auctions.vue').default);
const Lot = Vue.component('Lot', require('../components/Lot.vue').default);
const Details = Vue.component('Details', require('../components/Details.vue').default);
const Bid = Vue.component('Bid', require('../components/Bid.vue').default);
const VideoArchive = Vue.component('VideoArchive', require('../components/VideoArchive.vue').default);
const HowToSell = Vue.component('HowToSell', require("../components/HowToSell.vue").default);
const Home = Vue.component('Home', require("../components/Home.vue").default);
const AccountCreated = Vue.component('AccountCreated', require("../components/AccountCreated.vue").default);
const ArtQuiz = Vue.component('ArtQuiz', require("../components/ArtQuiz.vue").default);
const ArtDetective = Vue.component('ArtDetective', require("../components/ArtDetective.vue").default);
let router = new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'active',
    fallback: true,
    routes: [
        {
            path: '/:locale/umjetnik/:artist',
            name: 'artist',
            meta: { isArtist: true },
            component: Artist,
            props: true,
        },
        {
            path: '/:locale/artist/:artist',
            name: 'artist',
            meta: { isArtist: true },
            component: Artist,
            props: true,
        },
        {
            path: '*',
            component: NotFound
        },
        {
            path: '/:locale/contul-meu/succes',
            name: 'account-created',
            component: AccountCreated,
            props: true,
        },
        {
            path: '/:locale/my-account/success',
            name: 'account-created',
            component: AccountCreated,
            props: true,
        },
        {
            path: '/:locale/moj-racun/uspjeh',
            name: 'account-created',
            component: AccountCreated,
            props: true,
        },
        {
            path: '/:locale/auctions/benefit/:type/:page?',
            name: 'auctionsBenefit',
            component: Auctions,
            props: true,
            meta: {
                benefit: true
            }
        },
        {
            path: '/:locale/licitatii/caritabile/:type/:page?',
            name: 'auctionsBenefit',
            component: Auctions,
            props: true,
            meta: {
                benefit: true
            }
        },
        {
            path: '/:locale/aukcije/dobrotvorne/:type/:page?',
            name: 'auctionsBenefit',
            component: Auctions,
            props: true,
            meta: {
                benefit: true
            }
        },
        {
            path: '/:locale/auctions/:type/:page?',
            name: 'auctions',
            component: Auctions,
            props: true,
            meta: {
                benefit: false
            }
        },
        {
            path: '/:locale/licitatii/:type/:page?',
            name: 'auctions',
            component: Auctions,
            props: true,
            meta: {
                benefit: false 
            }
        },
        {
            path: '/:locale/aukcije/:type/:page?',
            name: 'auctions',
            component: Auctions,
            props: true,
            meta: {
                benefit: false
            }
        },
        {
            path: '/:locale/lot/:lot',
            name: 'standaloneLot',
            component: Details,
            props: true
        },
        {
            path: '/:locale/:localized/:auction/lot/:lot',
            name: 'lot',
            component: Details,
            props: true
        },
        {
            path: '/:locale/:localized/:auction/:sold?/:page?',
            name: 'auction',
            component: Auction,
            props: true
        },
        // {
        //     path: '/:locale/licitatie/:auction/:page?',
        //     name: 'auction',
        //     component: Auction,
        //     props: true
        // },

        // {
        //     path: '/:locale/licitatie/:auction/lot/:lot',
        //     name: 'lot',
        //     component: Details,
        //     props: true
        // },
        {
            path: '/:locale/tv',
            name: 'tv',
            component: VideoArchive,
            props: true
        },
        {
            path: '/:locale/how-to-sell',
            name: 'how-to-sell',
            component: HowToSell,
            props: true
        },
        {
            path: '/:locale/cum-vand',
            name: 'cum-vand',
            component: HowToSell,
            props: true
        },
        {
            path: '/:locale/kako-prodati',
            name: 'kako-prodati',
            component: HowToSell,
            props: true
        },
        {
            path: '/:locale/my-account',
            name: 'home',
            component: Home,
            props: true,
        },
        {
            path: '/:locale/contul-meu',
            name: 'home',
            component: Home,
            props: true,
        },
        {
            path: '/:locale/moj-racun',
            name: 'home',
            component: Home,
            props: true,
        },
        {
            path: '/:locale/home',
            name: 'home-logged',
            component: Home,
            props: true,
        },
        // {
        //     path: '/:locale/cauta',
        //     name: 'cauta',
        //     meta: { isSearch: true },
        //     component: Lot,
        //     props: true,
        // },
        // {
        //     path: '/:locale/search',
        //     name: 'search',
        //     meta: { isSearch: true },
        //     component: Lot,
        //     props: true,
        // },
        {
            path: '/:locale/cauta',
            name: 'cauta',
            meta: { isSearch: true },
            component: Search,
            props: true,
        },
        {
            path: '/:locale/search',
            name: 'search',
            meta: { isSearch: true },
            component: Search,
            props: true,
        },
        {
            path: '/:locale/pretraga',
            name: 'pretraga',
            meta: { isSearch: true },
            component: Search,
            props: true,
        },

    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.name === 'auction') {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
});

router.onReady(() => {
    console.log('-- Router Instance Ready --')
})

export default router
